<template>
  <v-container fluid grid-list-lg>
        <v-layout wrap > 
            <v-flex lg4 sm6 xs12>
                <v-text-field type="text" label="Razón Social" v-model="value.apellido" v-validate="'required'" data-vv-name="razonSocial" :error-messages="errors.collect('razón social')"></v-text-field>
            </v-flex>

            <v-flex lg4 sm6 xs12>
                <v-text-field label="Nombre Fantasía" v-model="value.nombre" v-validate="'required'" data-vv-name="nombreFantasia" :error-messages="errors.collect('nombre fantasía')"></v-text-field>
            </v-flex>
            
            <v-flex lg4 class="hidden-md-and-down"> </v-flex>
            
            <v-flex lg3 sm6 xs12>
                <v-text-field label="Cuit" v-model="value.cui" mask="##-########-#" clearable v-validate="'required'" data-vv-name="cuit"
                ></v-text-field>
            </v-flex>

            <v-flex lg3 sm6 xs12>
                <v-text-field label="Fecha Inicio Actividades" v-model="value.fechaNacimiento" type="date" prepend-icon="event" v-validate="'required'" data-vv-name="inicio de actividades"></v-text-field>
            </v-flex>

            <v-flex lg3 sm6 xs12>
                <v-text-field label="Cuenta/Legajo" v-model="value.cuenta" ></v-text-field>
            </v-flex>

            <v-flex lg3 sm6 xs12>
                <v-autocomplete v-model="value.tamañoEmpresaId" :items="listTamaños" 
                    item-text="descripcion" item-value="id" label="Tamaño"  :menu-props="{minWidth:'200'}"></v-autocomplete>
            </v-flex>
           
            <v-flex lg3 sm6 xs12>
                <v-autocomplete v-model="value.tipoActividadLaboralId" :items="listActividadesLaborales" 
                    item-text="descripcion" item-value="id" label="Actividad" :menu-props="{minWidth:'200'}"></v-autocomplete>
            </v-flex>            

            <v-flex lg3 sm6 xs12>
                <v-autocomplete v-model="value.tipoIvaPersonaId" :items="listTiposIva" 
                    item-text="descripcion" item-value="id" label="Condición IVA" :menu-props="{minWidth:'200'}"></v-autocomplete>
            </v-flex>           

            <v-flex lg4 class="hidden-md-and-down"> </v-flex>

            <v-flex>
                <v-layout> 
                    <v-flex >
                        <app-manejo-domicilios propName= "domicilios" :value="value" ></app-manejo-domicilios>
                    </v-flex>
                </v-layout>
                
            </v-flex>        
        </v-layout>        
    </v-container>
</template>

<script>

import Vue from 'vue'
import { http } from '@/axios'

import {
  mapState,
  mapGetters,
  mapMutations,
  mapActions
} from 'vuex'

export default {
  data() {
      return {
        loading:false,
        listActividadesLaborales: [],
        listTamaños: [],
        listTiposIva: []
      }
    },
  props: {
    value: {
      type: Object,
      required: true
    },
    editMode: {
      type: Boolean,
      default: true
    },
  },
  created () {
    this.loadActividadesLaborales();
    this.loadTamaños();
    this.loadTiposIva();
  },
  watch:{
      'value.nombre':function() {
          this.value.nombre = this.value.nombre.toUpperCase();
      },
      'value.apellido':function() {
          this.value.apellido = this.value.apellido.toUpperCase();
      }
  },
  methods:{
    ...mapMutations(["alertClear", "alertSuccess", "alertWarning", "alertError"]),
    async loadActividadesLaborales(){
        this.loading = true
        try {
            var result = await http.get('tiposactividadlaboral'); // traigo todas
            this.listActividadesLaborales = result.list;
        } catch (error) {
            // Error
            Vue.$log.error(error);
            this.alertError(error)
        }
        this.loading = false
    },
    async loadTamaños(){
        this.loading = true
        try {
            var result = await http.get('tipostamañoempresa'); // traigo todas
            this.listTamaños = result.list;
        } catch (error) {
            // Error
            Vue.$log.error(error);
            this.alertError(error)
        }
        this.loading = false
    },
     async loadTiposIva(){
        this.loading = true
        try {
            var result = await http.get('tiposivapersona'); // traigo todas
            this.listTiposIva = result.list;
        } catch (error) {
            // Error
            Vue.$log.error(error);
            this.alertError(error)
        }
        this.loading = false
    },
    
    }
}

</script>

<style>

</style>